import { COMMON_ASSETS_PATH } from "@ipru-common/constants/SiteConstants";
import React from "react";
import useMobileView from "@ipru-common/hooks/useMobileView";

const MainLogo = () => {
  const isMobileView = useMobileView();
  return (
    <img
      className="md:h-[43px] md:w-[126px] h-[25px] w-[73px] cursor-pointer object-fill"
      style={{ width: isMobileView ? "73px" : "126px" }}
      onClick={() => window.open("http://www.icicilife.com", "_self")}
      src={`${COMMON_ASSETS_PATH}/header/icici-life-logo.svg`}
      alt="icicibanner"
    />
  );
};

export default MainLogo;
